const MODERN_EXPO_LOGO_PATH =
  "M46.5806 22H58.4645V19.0033H50.671V17.3712H58.4645V14.5217H50.671V12.9833H58.4645V10.0134H46.5806V22.0134V22ZM19.0839 26H30.6581V22H19.0839V26ZM30.6581 6H19.0839V10H30.6581V6ZM150.129 9.79933C145.626 9.79933 142.258 12.6087 142.258 15.9933C142.258 19.3779 145.639 22.1873 150.129 22.1873C154.619 22.1873 158 19.3779 158 15.9933C158 12.6087 154.619 9.79933 150.129 9.79933ZM150.129 19.0033C147.961 19.0033 146.529 17.7057 146.529 15.9933C146.529 14.2809 147.961 12.9833 150.129 12.9833C152.297 12.9833 153.729 14.2809 153.729 15.9933C153.729 17.7057 152.297 19.0033 150.129 19.0033ZM87.7032 19.0033H87.4323L83.7032 10H76.4645V22H80.5161V12.9833H80.8L84.529 22H91.7548V10H87.7032V19.0033ZM135.897 10H127.794V22H131.884V18.4147H135.897C139.097 18.4147 141.355 16.7425 141.355 14.1605C141.355 11.5786 139.097 10.0134 135.897 10.0134V10ZM135.897 15.3244H131.884V12.9699H135.897C136.723 12.9699 137.148 13.5853 137.148 14.1472C137.148 14.709 136.723 15.3244 135.897 15.3244ZM74.8 14.0803C74.8 11.4047 72.5419 10 69.3419 10H60.7613V22H64.8516V18.2274H67.9355L70.4258 22H74.9935L72.1548 17.786C73.7806 17.1304 74.8 15.7525 74.8 14.0936V14.0803ZM69.3419 15.1906H64.8645V12.9833H69.3419C70.1677 12.9833 70.5935 13.4247 70.5935 14.0936C70.5935 14.7625 70.1677 15.204 69.3419 15.204V15.1906ZM98 22H109.884V19.0033H102.09V17.3712H109.884V14.5217H102.09V12.9833H109.884V10.0134H98V22.0134V22ZM122.194 10L118.903 13.6789L115.613 10H110.748L116.232 15.9264L110.748 22H115.613L118.903 18.2408L122.194 21.9866H127.032L121.574 15.913L127.045 9.98662H122.206L122.194 10ZM11.7935 10L9.45806 18.2007L7.12258 10H0V22H3.93548V12.9833H4.19355L6.76129 22H12.1548L14.7484 12.9833H14.9935V22H19.0839V10H11.7935ZM37.6903 10H30.6581V22H37.6903C42.1419 22 45.2774 19.7659 45.2774 16.0067C45.2774 12.2475 42.1419 10.0134 37.6903 10.0134V10ZM37.6903 19.0033H34.7484V12.9699H37.6903C39.6774 12.9699 41.0065 14.4147 41.0065 15.9933C41.0065 17.5719 39.6903 19.0033 37.6903 19.0033Z";

function initSolutionLogoMorph() {
  const logos = document.querySelectorAll(".navbar__logo-icon");
  if (!logos.length) return;

  if (!window.gsap || !window.MorphSVGPlugin) {
    console.warn(
      "Solution logo morph requires GSAP and MorphSVGPlugin to load before solutions_bundle.js."
    );
    return;
  }

  window.gsap.registerPlugin(window.MorphSVGPlugin);

  logos.forEach((svg) => {
    const sourcePath = svg.querySelector("path");
    const trigger = svg.closest(".navbar__logo");

    if (!sourcePath || !trigger) return;
    if (svg.dataset.solutionLogoMorphInitialized === "true") return;

    svg.dataset.solutionLogoMorphInitialized = "true";

    const timeline = window.gsap.timeline({
      paused: true,
      defaults: {
        duration: 0.7,
        ease: "power2.inOut",
      },
    });

    timeline
      .to(
        sourcePath,
        {
          morphSVG: {
            shape: MODERN_EXPO_LOGO_PATH,
            map: "position",
          },
        },
        0
      )
      .to(
        svg,
        {
          attr: {
            viewBox: "0 0 170 30",
          },
        },
        0
      );

    trigger.addEventListener("pointerenter", () => timeline.play());
    trigger.addEventListener("pointerleave", () => timeline.reverse());
    trigger.addEventListener("focus", () => timeline.play());
    trigger.addEventListener("blur", () => timeline.reverse());
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSolutionLogoMorph);
} else {
  initSolutionLogoMorph();
}
